import React, { useEffect } from 'react';
import { useQuestionBook } from '@/hooks/useQuestionBook';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { ExercisesCardPlayful } from './ExercisesCardPlayful';

export function ExercisesArchivePlayful() {
  const { questionBooks, getQuestionBooks, deleteQuestionBook, loading } = useQuestionBook();

  useEffect(() => {
    getQuestionBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredBooks = questionBooks.filter(book => book['question-count'] > 0);

  return (
    <div>
      {loading && <Loader />}

      {!loading && filteredBooks.length === 0 && <EmptyState type="data" />}

      {!loading && filteredBooks.length > 0 && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filteredBooks.map(book => (
            <ExercisesCardPlayful
              key={book.id}
              book={book}
              onDelete={deleteQuestionBook}
            />
          ))}
        </div>
      )}
    </div>
  );
}
